import { unitDefault, unitTypes } from "@/settings/unitTypes";
export const LatheCycle = {
  id: "33",
  name: "Lathe",
  mainClass: "Rotary",
  subtype: "Cycle",
  variables: [
    {
      type: unitTypes.percentage,
      unit: unitDefault.percentage.metric,
      code: "concentration",
      groups: "Cooling Lubricant",
      min: 0,
      max: 11,
      values: [5, 6, 9, 10]
    },
    {
      type: unitTypes.pH,
      unit: unitDefault.pH.metric,
      code: "pH",
      groups: "Cooling Lubricant",
      min: 0,
      max: 14,
      values: [8.5, 8.8, 9.5, 10]
    },
    {
      type: unitTypes.unique,
      unit: unitDefault.unique.metric,
      code: "nitrite",
      groups: "Cooling Lubricant",
      min: 0,
      max: 14,
      values: [8.5, 8.8, 9.5, 10]
    }
  ],
  operationalValues: [
    {
      value: 7,
      type: unitTypes.percentage,
      unit: unitDefault.percentage.metric,
      code: "concentration"
    },

    {
      value: "",
      type: unitTypes.unique,
      unit: unitDefault.unique.metric,
      code: "coolingLubricantCode"
    },
    {
      value: 9.2,
      type: unitTypes.pH,
      unit: unitDefault.pH.metric,
      code: "pH"
    },
    {
      value: 5,
      type: unitTypes.unique,
      unit: unitDefault.unique.metric,
      code: "nitrite"
    }
  ]
};
